import { useEffect } from 'react'
import { type ToastService, useToastService } from './toast-service'

export type UseToastsOptions<T> = {
  items?: T[]
  getToast: (item: T) => Parameters<ToastService['addToast']>[0]
}

/** Adds toasts for the specified items to the toast service when this hook is mounted, and removes them when this hook is unmounted. */
export function useToasts<T>({ items, getToast }: UseToastsOptions<T>) {
  const toastService = useToastService()

  return useToastsPure({ toastService, items, getToast })
}

type UseToastsPureOptions<T> = UseToastsOptions<T> & {
  toastService: Pick<ToastService, 'addToast' | 'removeToast'>
}

export function useToastsPure<T>({
  toastService: { addToast, removeToast },
  items,
  getToast,
}: UseToastsPureOptions<T>) {
  useEffect(() => {
    if (items) {
      const toasts = items.map(item => addToast(getToast(item)))

      return () => {
        toasts.map(({ id }) => id).forEach(removeToast)
      }
    }

    return undefined
  }, [items, addToast, removeToast, getToast])
}
